import axios from "../../../../../api/axios"
import { Link } from "react-router-dom"
import React,{ useEffect, useState } from "react"
import { getCookie, isEmpty } from "../../../../../Utilities/Utils"
import { useNavigate } from "react-router-dom"
import { useAuth } from "../../../../../ContextApp/AuthContext"
import './bulletincss.css'
function My_bulletin(){
const {user}=useAuth()
const [showFilters, setShowFilters] = useState(false);
const [eleves,setEleves]=useState([])
const [classes,setClasses]=useState([])
const [cotes,setCotes]=useState([])
const [bulletin,setBulletin]=useState([]) 
const [My_ecole,setMy_ecole]=useState("")
const [periode,setPeriode]=useState("")
const [eleve,setEleve]=useState("")
const [date_evaluation,setDate_evaluation]=useState()
const [loading,setLoading]=useState(false)
const [classe,setClasse]=useState("")
const [cours,setCours]=useState([])
const [mes_cotes,setMes_cotes]=useState([])
const [deliberations,setDeliberations]=useState([])
const [p1,setP1]=useState([])
const [totalite,setTotalite]=useState([])
let cot=0
const [p2,setP2]=useState([])
let navigate=useNavigate()
//const record_classe=classes.filter((clas)=>clas.id==classe)
const recordseleves=eleves.filter((eleve)=>eleve.idclasse==Number(classe))
const dataeleve=recordseleves.filter((elev)=>elev.id==Number(eleve))
const dataclasse=classes.filter((clas)=>clas.id==Number(classe))
const classe_initiale=!isEmpty(dataclasse) && dataclasse[0].idclasse_initiale 
const mes_cours=cours.filter((cour)=>cour.idclasse_initiale==Number(classe_initiale))
const filter_deliberations=deliberations.filter((delib)=>delib?.niveau===Number(dataclasse[0]?.niveau) && delib?.idsection_organisee===dataclasse[0]?.section)
useEffect(()=>{
    HandleClassesTitulariat()
    elevesrequest()
    getbulletin()
    getEcole()
    handleDeliberation()
},[])
const HandleClassesTitulariat=async()=>{
    await axios.post(`api/getclassetitulariat/${user?.ecole[0]?.id}/${user?.ecole[0]?.idenseignant}`,{idecole:user?.ecole[0]?.id,annee_scolaire:user?.programme_scolaire?.annee_scolaire,idenseignant:user?.ecole[0]?.idenseignant}).then((res)=>{
        setClasses(res.data.items)       
    }).catch((err)=>{})
}
/*const HandleRequest=async()=>{
    await axios.post('api/classes_getter',{idecole:user?.ecole[0]?.id}).then((res)=>{
        setClasses(res.data.items)
    }).catch((err)=>{
        
    })
}*/
 const handleDeliberation=async()=>{        
        //{params:{idecole:user?.ecole?.id,annee_scolaire:user?.programme_scolaire?.annee_scolaire}}
        await axios.get('api/Deliberation',{params:{idecole:user?.ecole[0]?.id,annee_scolaire:user?.programme_scolaire?.annee_scolaire}}).then((res)=>{
            setDeliberations(res?.data?.items)
        }).catch((err)=>{})
    }
const getEcole=async()=>{
    await axios.get(`api/getEcole/${user?.ecole[0]?.id}`).then((res)=>{
        setMy_ecole(res.data.items)
    }).catch((err)=>{
    })
}
const elevesrequest=async()=>{
    await axios.post("api/allinscription",{idecole:user?.ecole[0]?.id,annee_scolaire:user?.programme_scolaire?.annee_scolaire}).then((res)=>{
        setEleves(res?.data?.items)  
    }).catch((err)=>{
    })
}
const getbulletin=async()=>{
    await axios.post("api/getbulletin",{idecole:user?.ecole[0]?.id,annee_scolaire:user?.programme_scolaire?.annee_scolaire}).then((res)=>{
        setCours(res?.data?.cours)
        setCotes(res?.data?.tableau)
        setTotalite(res?.data?.total)
    }).catch((err)=>{
    })
}
function getponderation(){
    let table_ponderation=[]
    if(mes_cours.length>0){     
        for(let i=0;i<mes_cours.length;i++){
            table_ponderation=[...table_ponderation,mes_cours[i].ponderation]           
        }
        const unique_ponderation=[...new Set(table_ponderation)]
        return unique_ponderation
    }    
}
function total(idinscription,idcour,ponderation){
  let cot1= cotes.filter((cote)=>cote.idinscription==idinscription && cote.my_course==idcour && cote.periode=="P1");
  let cot2= cotes.filter((cote)=>cote.idinscription==idinscription && cote.my_course==idcour && cote.periode=="P2");
  let cot3= cotes.filter((cote)=>cote.idinscription==idinscription && cote.my_course==idcour && cote.periode=="Examen1");
  let resultat=cot1[0]?.somme_point*ponderation/cot1[0]?.ponderation+cot2[0]?.somme_point*ponderation/cot2[0]?.ponderation+cot3[0]?.somme_point*ponderation*2/cot3[0]?.ponderation
return(parseInt(resultat))
}
function total2(idinscription,idcour,ponderation){
    let cot1= cotes.filter((cote)=>cote.idinscription==idinscription && cote.my_course==idcour && cote.periode=="P3");
    let cot2= cotes.filter((cote)=>cote.idinscription==idinscription && cote.my_course==idcour && cote.periode=="P4");
    let cot3= cotes.filter((cote)=>cote.idinscription==idinscription && cote.my_course==idcour && cote.periode=="Examen2");  
    let resultat=cot1[0]?.somme_point*ponderation/cot1[0]?.ponderation+cot2[0]?.somme_point*ponderation/cot2[0]?.ponderation+cot3[0]?.somme_point*ponderation*2/cot3[0]?.ponderation
  return(parseInt(resultat))
  }
function getpoint_eleve(){
    let my_table=[]
    if(!isEmpty(eleve)){
        mes_cours.map((cour)=>{
           const my_cote_now=cotes.filter((cote)=>cote.idinscription==eleve && cote.my_course==cour.id)
           const p1=my_cote_now.filter((cote)=>cote.periode=="P1")
           const p2=my_cote_now.filter((cote)=>cote.periode=="P2")
           const p3=my_cote_now.filter((cote)=>cote.periode=="P3")
           const p4=my_cote_now.filter((cote)=>cote.periode=="P4")
           const Exam1=my_cote_now.filter((cote)=>cote.periode=="Examen1")
           const Exam2=my_cote_now.filter((cote)=>cote.periode=="Examen2")
           my_table=[
                ...my_table,
                {
                    mon_cour:cour.nom,
                    idcour:cour.id,
                    p1:parseInt(p1[0]?.somme_point),
                    p2:parseInt(p2[0]?.somme_point),
                    tot1:parseInt(p1[0]?.somme_point)+parseInt(p2[0]?.somme_point)+parseInt(Exam1[0]?.somme_point),
                    p3:parseInt(p3[0]?.somme_point),
                    p4:parseInt(p4[0]?.somme_point),
                    Examen1:parseInt(Exam1[0]?.somme_point),
                    Examen2:parseInt(Exam2[0]?.somme_point),
                },
            ]
            
            
        }
          
        )
    }
   return my_table
}
function maximum(){
    let sum=0
   const nombre_cour=mes_cours.length
   if(nombre_cour>0){
    for(let i=0;i<nombre_cour;i++){
        sum=parseInt(sum)+parseInt(mes_cours[i]?.ponderation)
       
    }
   }

   return(sum)
}
function totaux(eleve,periode){
    let tot=0
    
    if(periode=="Examen1" || periode=="Examen2"){
    for(let i=0;i<mes_cours.length;i++){
        let cour_pond=mes_cours.filter((cour)=>cour.id==mes_cours[i]?.id)
        const mes_points=cotes.filter((cote)=>cote.idinscription==eleve && cote.periode==periode && cote.my_course==mes_cours[i].id)
            tot=parseInt(tot)+parseInt((parseInt(mes_points[0]?.somme_point)*cour_pond[0]?.ponderation*2)/parseInt(mes_points[0]?.ponderation))
        }
        }
        else{
            for(let i=0;i<mes_cours.length;i++){
                let cour_pond=mes_cours.filter((cour)=>cour.id==mes_cours[i]?.id)
                const mes_points=cotes.filter((cote)=>cote.idinscription==eleve && cote.periode==periode && cote.my_course==mes_cours[i].id)
            tot=parseInt(tot)+parseInt((parseInt(mes_points[0]?.somme_point)*cour_pond[0]?.ponderation)/parseInt(mes_points[0]?.ponderation))
            }
        }   
return (tot)
}
const totalitete=cotes.filter((cote)=>cote.idinscription==eleve && cote.periode=="P1" && cote.my_course==11)
function totauxgen(eleve,periode){
    let tot1=0
    let tot2=0
    let tot3=0
    if(periode=="tot1"){
        const mes_points1=cotes.filter((cote)=>cote.idinscription==eleve && cote.periode=="P1")
        const mes_points2=cotes.filter((cote)=>cote.idinscription==eleve && cote.periode=="P2")
        const mes_points3=cotes.filter((cote)=>cote.idinscription==eleve && cote.periode=="Examen1")
        for(let i=0;i<mes_points1.length;i++){
            let cour_pond=mes_cours.filter((cour)=>cour.id==mes_points1[i]?.my_course)
            tot1=parseInt(tot1)+parseInt((parseInt(mes_points1[i]?.somme_point)*cour_pond[0]?.ponderation)/parseInt(mes_points1[i]?.ponderation))
        }
        for(let i=0;i<mes_points2.length;i++){
            let cour_pond=mes_cours.filter((cour)=>cour.id==mes_points2[i]?.my_course)
            tot2=parseInt(tot2)+parseInt((parseInt(mes_points2[i]?.somme_point)*cour_pond[0]?.ponderation)/parseInt(mes_points2[i]?.ponderation))
        }
        for(let i=0;i<mes_points3.length;i++){
            let cour_pond=mes_cours.filter((cour)=>cour.id==mes_points3[i]?.my_course)
            tot3=parseInt(tot3)+parseInt((parseInt(mes_points3[i]?.somme_point)*cour_pond[0]?.ponderation*2)/parseInt(mes_points3[i]?.ponderation))
        }
    }
    else{
        const mes_points1=cotes.filter((cote)=>cote.idinscription==eleve && cote.periode=="P3")
        const mes_points2=cotes.filter((cote)=>cote.idinscription==eleve && cote.periode=="P4")
        const mes_points3=cotes.filter((cote)=>cote.idinscription==eleve && cote.periode=="Examen2")
        for(let i=0;i<mes_points1.length;i++){
            let cour_pond=mes_cours.filter((cour)=>cour.id==mes_points1[i]?.my_course)
            tot1=parseInt(tot1)+parseInt((parseInt(mes_points1[i]?.somme_point)*cour_pond[0]?.ponderation)/parseInt(mes_points1[i]?.ponderation))
        }
        for(let i=0;i<mes_points2.length;i++){
            let cour_pond=mes_cours.filter((cour)=>cour.id==mes_points2[i]?.my_course)
            tot2=parseInt(tot2)+parseInt((parseInt(mes_points2[i]?.somme_point)*cour_pond[0]?.ponderation)/parseInt(mes_points2[i]?.ponderation))
        }
        for(let i=0;i<mes_points3.length;i++){
            let cour_pond=mes_cours.filter((cour)=>cour.id==mes_points3[i]?.my_course)
            tot3=parseInt(tot3)+parseInt((parseInt(mes_points3[i]?.somme_point)*cour_pond[0]?.ponderation*2)/parseInt(mes_points3[i]?.ponderation))
        }
    }
    return(tot1+tot2+tot3)
}
function place(eleve,periode){
    tableaupourcent(periode)
    //const total_point=totalite.filter((tot)=>tot.periode==periode)    
    let my_place=""
    if(tableaupercent.length>0){
        my_place=tableaupercent.findIndex(element=>element.idinscription==eleve)
    }
    return (my_place)
}
const HandleClick=async()=>{
    await axios.post("api/personnalbulletin").then((res)=>{
    }).catch((err)=>{
    })
}
let tableaupercent = [];
const tableaupourcent = (periode) => {
    tableaupercent=[]
    let pourcent = 0;
    let totalpart=0;
    let totalpart2=0;
    const recordtotalite=totalite.filter((tota)=>tota.periode==periode && tota.idclasse==classe)
    const recordtotalitesem=totalite.filter((tota)=>tota.idclasse==classe)
    if(periode==="Examen1" || periode==="Examen2"){
        recordtotalite.map((record) => {
            recordseleves.filter((rec) => rec.id == record.idinscription).map((elv) => {
                pourcent = ((totaux(elv.id, periode) / maximum()*2) * 100).toFixed(2);
                tableaupercent.push({ idinscription: elv.id, pourcent: pourcent });
            });
        });
    }
    else if(periode==="tot1"){
        recordtotalitesem.map((record) => {
            recordseleves.filter((rec) => rec.id == record.idinscription).map((elv) => {
                totalpart=totauxgen(elv.id,"tot1")
                //totalpart=totaux(elv.id,"P1")+totaux(elv.id,"P2")+totaux(elv.id,"Examen1")
                pourcent = ((parseInt(totalpart) / (maximum()*4)) * 100).toFixed(2);
                if (!tableaupercent.some(e => e.idinscription === elv.id && e.pourcent === pourcent)) {
                    tableaupercent.push({ idinscription: elv.id, pourcent: pourcent });
                  }
            });
        });
    }
    else if(periode==="tot2"){
        recordtotalitesem.map((record) => {
            recordseleves.filter((rec) => rec.id == record.idinscription).map((elv) => {
                totalpart=totauxgen(elv.id,"tot2")
                //totalpart=totaux(elv.id,"P1")+totaux(elv.id,"P2")+totaux(elv.id,"Examen1")
                pourcent = ((parseInt(totalpart) / (maximum()*4)) * 100).toFixed(2);
                if (!tableaupercent.some(e => e.idinscription === elv.id && e.pourcent === pourcent)) {
                    tableaupercent.push({ idinscription: elv.id, pourcent: pourcent });
                  }
            });
        });
    }
    else if(periode==="totGen"){
        recordtotalitesem.map((record) => {
            recordseleves.filter((rec) => rec.id == record.idinscription).map((elv) => {
                totalpart=totauxgen(elv.id,"tot1")
                totalpart2=totauxgen(elv.id,"tot2")
                //totalpart=totaux(elv.id,"P1")+totaux(elv.id,"P2")+totaux(elv.id,"Examen1")
                pourcent = (((parseInt(totalpart)+parseInt(totalpart2)) / (maximum()*8)) * 100).toFixed(2);
                if (!tableaupercent.some(e => e.idinscription === elv.id && e.pourcent === pourcent)) {
                    tableaupercent.push({ idinscription: elv.id, pourcent: pourcent });
                  }
            });
        });
    }
    else{
        recordtotalite.map((record) => {
            recordseleves.filter((rec) => rec.id == record.idinscription).map((elv) => {
                pourcent = ((totaux(elv.id, periode) / maximum()) * 100).toFixed(2);
                tableaupercent.push({ idinscription: elv.id, pourcent: pourcent });
            });
        });
    }
    tableaupercent.sort((a, b) => b.pourcent - a.pourcent);
};
    return (
        <div className="container-fluid py-4 bg-light min-vh-100">
            
            <div className="row justify-content-center">
                <div className="col-lg-11">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h5 className="mb-0 text-muted small fw-bold text-uppercase">Configurations</h5>
                        <button 
                            className="btn btn-sm btn-light border-0 shadow-sm" 
                            onClick={() => setShowFilters(!showFilters)}
                        >
                            {showFilters ? (
                                <span><i className="bi bi-chevron-up me-1"></i> Masquer les filtres</span>
                            ) : (
                                <span><i className="bi bi-filter me-1"></i> Afficher les filtres</span>
                            )}
                        </button>
                    </div>  
                    {/* --- SECTION 1 : FILTRES & ACTIONS --- */}
                     <div className={`card border-0 shadow-sm mb-4 p-3 transition-collapse ${showFilters ? 'd-block' : 'd-none'}`}>  
                        <div className="card-body p-3 p-md-4">
                            <div className="row g-3 align-items-end">
                                <div className="col-md-4">
                                    <label className="form-label fw-bold text-secondary small text-uppercase">Classe</label>
                                    <select onChange={(e)=>setClasse(e.target.value)} value={classe} className="form-select form-select-lg border-light-subtle fs-6 shadow-sm">
                                        <option value="" disabled>Choix de la classe</option>
                                        {classes.map((clas) => (
                                            <option value={Number(clas?.id)} key={clas.id}>{clas?.nom}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-5">
                                    <label className="form-label fw-bold text-secondary small text-uppercase">Élève</label>
                                    <select className="form-select form-select-lg border-light-subtle fs-6 shadow-sm" onChange={(e)=>setEleve(e.target.value)} value={eleve}>
                                        <option value="">Choix de l'élève</option>
                                        <option value="Tous">Tous les élèves</option>
                                        {recordseleves.map((elev) => (
                                            <option key={elev.id} value={elev.id}>{elev.nom_complet}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-3">
                                    <Link 
                                        to={!isEmpty(eleve) && eleve !== "Tous" ? `/mybulletin/${false}/${classe}/${eleve}` : !isEmpty(eleve) && eleve === "Tous" ? `/mybulletin/${true}/${classe}/tous` : "/mybulletin"} 
                                        className={`btn btn-primary btn-lg w-100 fw-bold rounded-3 shadow ${isEmpty(eleve) ? 'disabled' : ''}`}
                                    >
                                        <i className="bi bi-printer-fill me-2"></i> Télécharger
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* --- SECTION 2 : LE BULLETIN (APERÇU RÉEL) --- */}
                    <div className="card border-0 p-3 p-md-5 shadow-lg rounded-0 mx-auto mb-5" style={{ maxWidth: '1050px', backgroundColor: '#fff', color: '#1a1a1a' }}>
                        <div className="card-body border border-dark  ">
                            
                            {/* En-tête National */}
                            <div className="text-center mb-4">
                                <h6 className="fw-bold mb-1">RÉPUBLIQUE DÉMOCRATIQUE DU CONGO</h6>
                                <p className="small text-uppercase mb-0" style={{ fontSize: '0.7rem' }}>
                                    Ministère de l'Enseignement Primaire, Secondaire <br/>
                                    et Initiation à la Nouvelle Citoyenneté
                                </p>
                                <div className="mx-auto my-3 bg-dark" style={{ height: '2px', width: '80px' }}></div>
                            </div>
                            {/* Identification Bloc */}
                            <div className="row g-0 mb-4 border border-dark mx-0 d-flex flex-row flex-nowrap">
                                {/* On utilise col-6 au lieu de col-md-6 pour forcer 50% de largeur partout */}
                                <div className="col-6 border-end border-dark px-2 py-2">
                                    <h6 className="fw-bold mb-2" style={{fontSize: '0.65rem'}}>PROVINCE : <span className="text-muted">................</span></h6>
                                    <h6 className="fw-bold mb-1" style={{fontSize: '0.65rem'}}>VILLE : {My_ecole?.ville?.toUpperCase()}</h6>
                                    <h6 className="fw-bold mb-1" style={{fontSize: '0.65rem'}}>COMMUNE : {My_ecole?.commune?.toUpperCase()}</h6>
                                    <h6 className="fw-bold mb-1" style={{fontSize: '0.65rem'}}>ÉCOLE : {My_ecole?.nom?.toUpperCase()}</h6>
                                    <h6 className="fw-bold mb-0" style={{fontSize: '0.65rem'}}>CODE : {My_ecole?.code?.toUpperCase()}</h6>
                                </div>
                                
                                <div className="col-6 px-2 py-2">
                                    <h6 className="fw-bold mb-2" style={{fontSize: '0.65rem'}}>ÉLÈVE : <span className="text-primary">{dataeleve[0]?.nom_complet.toUpperCase()}</span></h6>
                                    <h6 className="fw-bold mb-1" style={{fontSize: '0.65rem'}}>
                                        NÉ(E) À : {isEmpty(dataeleve[0]?.lieu_naissance) ? `... LE ${dataeleve[0]?.date_naissance}` : `${dataeleve[0]?.lieu_naissance} LE ${dataeleve[0]?.date_naissance}`}
                                    </h6>
                                    <h6 className="fw-bold mb-1" style={{fontSize: '0.65rem'}}>CLASSE : {dataclasse[0]?.nom}</h6>
                                    <h6 className="fw-bold mb-0" style={{fontSize: '0.65rem'}}>N° PERM : {dataeleve[0]?.Numero_serni || '...........'}</h6>
                                </div>
                            </div>                       
                            {/* Tableau des Cotes */}
                            <div className="table-responsive shadow-sm border" style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
                                <table className="table table-bordered table-sm align-middle text-center mb-0" 
                                    style={{ 
                                        fontSize: '0.75rem', 
                                        minWidth: '750px', // Force une largeur minimale pour garder l'aspect tableau
                                        tableLayout: 'fixed' // Optionnel : aide à garder des colonnes régulières
                                    }}>
                                    <thead className="bg-dark text-white">
                                        <tr className="small">
                                             <th className="sticky-col bg-dark" style={{ position: 'sticky', left: 0, minWidth: '150px' }}>BRANCHES</th>
                                            <th style={{ width: '50px' }}>1ère P</th>
                                            <th style={{ width: '50px' }}>2ème P</th>
                                            <th style={{ width: '60px' }}>EXAM</th>
                                            <th className="bg-secondary text-white" style={{ width: '60px' }}>TOT.</th>                                    
                                            <th style={{ width: '50px' }}>3ème P</th>
                                            <th style={{ width: '50px' }}>4ème P</th>
                                            <th style={{ width: '60px' }}>EXAM</th>
                                            <th className="bg-secondary text-white" style={{ width: '60px' }}>TOT.</th>
                                            <th className="bg-primary text-white" style={{ width: '60px' }}>T.G</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {!isEmpty(getponderation()) && getponderation().map((pond, pIdx) => (
                                            <React.Fragment key={pIdx}>
                                                {/* Ligne MAXIMA pour ce groupe de cours */}
                                                <tr className="bg-light fw-bold">
                                                    <td className="sticky-col bg-light text-start ps-3">MAXIMA</td>
                                                    <td>{pond}</td><td>{pond}</td><td>{pond*2}</td>
                                                    <td className="bg-secondary-subtle">{pond*4}</td>
                                                    <td>{pond}</td><td>{pond}</td><td>{pond*2}</td>
                                                    <td className="bg-secondary-subtle">{pond*4}</td>
                                                    <td className="bg-primary-subtle text-primary">{pond*8}</td>
                                                </tr>
                                                {/* Détail des cours */}
                                                {mes_cours.filter(cr => cr.ponderation == pond).map((cr) => {
                                                    const s1 = total(eleve, cr.id, cr.ponderation);
                                                    const s2 = total2(eleve, cr.id, cr.ponderation);
                                                    return (
                                                        <tr key={cr.id}>
                                                            <td className="sticky-col bg-white text-start ps-3 text-uppercase" style={{ fontSize: '0.75rem' }}>{cr.nom}</td>
                                                            {["P1", "P2", "Examen1"].map(p => (
                                                                <td key={p}>{cotes.find(c => c.idinscription == eleve && c.my_course == cr.id && c.periode == p) ? Math.floor(cotes.find(c => c.idinscription == eleve && c.my_course == cr.id && c.periode == p).somme_point * (p === "Examen1" ? cr.ponderation * 2 : cr.ponderation) / cotes.find(c => c.idinscription == eleve && c.my_course == cr.id && c.periode == p).ponderation) : "-"}</td>
                                                            ))}
                                                            <td className="fw-bold bg-light">{s1 || "-"}</td>
                                                            {["P3", "P4", "Examen2"].map(p => (
                                                                <td key={p}>{cotes.find(c => c.idinscription == eleve && c.my_course == cr.id && c.periode == p) ? Math.floor(cotes.find(c => c.idinscription == eleve && c.my_course == cr.id && c.periode == p).somme_point * (p === "Examen2" ? cr.ponderation * 2 : cr.ponderation) / cotes.find(c => c.idinscription == eleve && c.my_course == cr.id && c.periode == p).ponderation) : "-"}</td>
                                                            ))}
                                                            <td className="fw-bold bg-light">{s2 || "-"}</td>
                                                            <td className="fw-bold bg-primary-subtle">{ (s1 && s2) ? s1 + s2 : "-"}</td>
                                                        </tr>
                                                    );
                                                })}
                                            </React.Fragment>
                                        ))}
                                    </tbody>  
                                    {/* Pied de tableau (Résumé final) */}
                                    <tfoot className="fw-bold border-top border-dark shadow-sm">
                                        <tr className="bg-light text-muted small">
                                             <td className="sticky-col bg-light text-start ps-3">MAXIMA GÉNÉRAUX</td>
                                            <td style={{ width: '50px' }}>{maximum()}</td>
                                            <td style={{ width: '50px' }}>{maximum()}</td>
                                            <td style={{ width: '60px' }}>{maximum()*2}</td>
                                            <td className="bg-secondary-subtle text-dark" style={{ width: '60px' }}>{maximum()*4}</td>
                                            <td style={{ width: '50px' }}>{maximum()}</td>
                                            <td style={{ width: '50px' }}>{maximum()}</td>
                                            <td style={{ width: '60px' }}>{maximum()*2}</td>
                                            <td className="bg-secondary-subtle text-dark" style={{ width: '60px' }}>{maximum()*4}</td>
                                            <td className="bg-dark text-white" style={{ width: '60px' }}>{maximum()*8}</td>
                                        </tr>
                                        <tr className="text-primary">
                                            <td className="sticky-col bg-light text-start ps-3">TOTAUX OBTENUS</td>
                                            <td>{totaux(eleve,"P1")}</td>
                                            <td>{totaux(eleve,"P2")}</td>
                                            <td>{totaux(eleve,"Examen1")}</td>
                                            <td className="bg-primary-subtle">{totauxgen(eleve,"tot1")}</td>
                                            <td>{totaux(eleve,"P3")}</td>
                                            <td>{totaux(eleve,"P4")}</td>
                                            <td>{totaux(eleve,"Examen2")}</td>
                                            <td className="bg-primary-subtle">{totauxgen(eleve,"tot2")}</td>
                                            <td className="bg-primary text-white">{totauxgen(eleve,"tot1")+totauxgen(eleve,"tot2")}</td>
                                        </tr>
                                        <tr>
                                             <td className="sticky-col bg-light text-start ps-3">POURCENTAGE</td>
                                            {/* Répétez ici vos calculs de % avec une couleur dynamique */}
                                            {["P1", "P2", "Examen1", "tot1", "P3", "P4", "Examen2", "tot2", "totGen"].map((p, i) => {
                                                const val = p === "totGen" ? (totauxgen(eleve,"tot1")+totauxgen(eleve,"tot2")) : p.includes('tot') ? totauxgen(eleve, p) : totaux(eleve, p);
                                                const max = p === "totGen" ? maximum()*8 : p.includes('tot') ? maximum()*4 : p.includes('Examen') ? maximum()*2 : maximum();
                                                const pct = ((val/max)*100).toFixed(1);
                                                return <td key={i} className={pct < 50 ? "text-danger" : "text-success"}>{pct}%</td>
                                            })}
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                            {/* Passation de classe */}
                            <div className="row mt-2 text-left small">
                                <div className="col-12">
                                    - L'élève ne pourra passer la classe supérieur s'il n'a subi avec succès un axamen de repêchage en :
                                            {  
                                              !Number.isNaN(totaux(eleve,"Examen2"))&&
                                                "On appelle maintenant la fonction de délibération" 
                                            }
                                </div>
                                <div className="col-12">- L'élève passe dans la classe supérieur (1) </div>
                                <div className="col-12">- L'élève double la classe (1)</div>
                            </div>
                            {/* Signatures */}
                            <div className="row mt-2 text-center small fw-bold">
                                <div className="col-4"><div className="border-top pt-2">Le Parent</div></div>
                                <div className="col-4"><div className="border-top pt-2">Sceau École</div></div>
                                <div className="col-4"><div className="border-top pt-2">Le Chef d'Établissement</div></div>
                            </div>
                            <div className="row mt-2 text-left small fs-12">
                                <div className="col-12">(1) Biffer la mention inutile.</div>
                                <div className="col-12">Note importante : Le bulletin est sans valeur s'il est raturé ou surchargé.</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default My_bulletin